<section class="pagination-wrapper">
    <div class="page-numbers">
        <mat-paginator
                paginator-style
                [length]="length"
                [pageSize]="pageSize"
                [showTotalPages]="showTotalPages"
                [pageSizeOptions]="pageSizeOptions"
        >
        </mat-paginator>
    </div>
</section>
